import React, { memo, ChangeEvent } from 'react'
import { Checkbox } from 'transfix-ui/components/Checkbox'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IIsDropProps {
  value: RecursivePartial<ISpotBiddingRule>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  dataTest?: string
}

export const IsDrop = memo<IIsDropProps>(({ dataTest, onChange, value }) => {
  const { isDrop, stopSpecificDropCriteria } = value

  const isDropChangeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      onChange({
        isDrop: checked,
        isMultiStop: !checked,
        transitDifferenceCriteria: undefined,
      })
    } else {
      onChange({
        isDrop: checked,
        isMultiStop: checked,
        stopSpecificDropCriteria: undefined,
      })
    }
  }
  const dropTypesChangeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      onChange({
        stopSpecificDropCriteria: {
          pickupDropTrailer: false,
          deliveryDropTrailer: false,
        },
      })
    } else {
      onChange({
        stopSpecificDropCriteria: undefined,
      })
    }
  }
  const showStopSpecificCheckbox = isDrop && !value.countLoadsQuotedCriteria

  return (
    <div className='row' data-test={dataTest}>
      <div className='w-100 col-md-6 col-xs-6'>
        <Checkbox label='Is Drop?' checked={isDrop} onChange={isDropChangeHandler} />
      </div>
      {showStopSpecificCheckbox && (
        <div className='col-md-6 col-xs-6'>
          <Checkbox
            label='Set PU/DEL Drop Types'
            checked={!!stopSpecificDropCriteria}
            onChange={dropTypesChangeHandler}
          />
        </div>
      )}
    </div>
  )
})
